<template>
    <div>     
        <div style=" display:flex; width:100%; background:#fff;line-height:30px;border-bottom:2px solid #389;padding-top:3px">
            <div style="min-width:1100px;display:flex">
                <i class="iconfont icon-xiazai" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                <el-link :disabled="addBool" @click="downRec" :underline="false" ><span style="font-size:12px;margin-right:25px;font-weight:600">下载钉钉用户</span></el-link>
                <span style=" font-size:12px;margin-right:11px;">字段查询</span>
                <el-select v-model="selparam"  placeholder="请选择列名" filterable  size="small" style="width:120px;  ">
                    <span v-for="item in tabArr" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input placeholder="请输入查询值" v-model="txtparam" size="small" @keyup.enter.native="qryTabData" style="width:310px; height:30px;  ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                </el-input> 

                <el-select v-model="selparam2"  placeholder="请选择列名" clearable size="small" style="width:120px; ">
                    <span v-for="item in tabArr" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input placeholder="请输入查询值" v-model="txtparam2" size="small" @keyup.enter.native="qryTabData" style="width:310px; height:30px;  ">
                    <el-select v-model="oper2" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                </el-input> 
            </div>
        </div> 
        <el-table  :data="tabData" 
                border                            
                disabled-hover
                class="custom-table-border"
                style="overflow:auto;margin-top:1px;"
                size="small"
                :cell-style="{padding:'2px'}"
                :header-cell-style="headStyle"
                :height="tabHeight" 
                :row-key="getRowKey"  
                ref="tabref" 
                @row-click="rowClick"
                highlight-current-row>
            <el-table-column label="序号" type="index" width="60"></el-table-column>
            <el-table-column  v-for="(item,index ) in tabArr.filter(item=>item.thide=='N')" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.key!=='RN'&&item.edcss!=='checkbox'"
                :min-width="item.width">
                <template   slot-scope="scope" >
                    <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" ></el-checkbox>
                    <span v-else v-text="scope.row[item.key]" ></span>
                </template>
            </el-table-column>
                      
        </el-table>  
 
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" width="1200px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style=" overflow-y:auto">
                <Form :model="perRow" :label-width="120"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in tabArr" :key="index" >
                        <FormItem  :label="item.title"  :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">                  
                            <el-date-picker   :disabled="saveFlag" type="date"  v-if="item.edcss==='date'" v-model="perRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
  
                            <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"    v-else-if="item.disabled=='N'&&item.edcss=='number'"  v-model="perRow[item.key]" style="width:100%"> </el-input> 
                            <el-checkbox   border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="perRow[item.key]" style="width:100%"></el-checkbox> 
                            <el-select filterable :disabled="saveFlag" v-else-if="item.edcss==='select'" v-model="perRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                            </el-select>
 
                            <el-input   type="text" v-else :disabled="item.disabled==='Y'?true:false||saveFlag "  v-model="perRow[item.key]"></el-input>
                        </FormItem>
                    </span>
                </Form>

            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">   
                <span style="float:right">
 
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="addWin=false" style="margin-right:50px;">取消</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-baocun"  :disabled="saveFlag?true:false" @click="saveRec" style="margin-right:10px;">保存</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
    </div>
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import {getDate} from '../../api/Select' 
//局部注册
export default {
    name:"emp_simple",
    data () {
        return {
            addWin:false,
            loadWin:false,
            mthArr:[],
            saveFlag:false,
            promptWin:false,
            prompt:'',
            stfgCss:'',
            perWin:false,
            stfgColor:'',
            perRow:{},
            menuList: [],
            openName:[], //模块ID集合
            cpWin:false,
            frmth:'',
            tomth:'',
            active:'', //二级菜单选中标志
 
            disabled:false, //新增权限制
 
            ruleValidate:{},
 
            tabData:[], //表数据
            tabArr:[], //表列 
            operArr:[],           
            comboArr:{},
            oper:'like',
            txtparam:'',
            selparam:'IDNO',
            oper2:'like',
            txtparam2:'',
            selparam2:'',
            delArr:[],
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            dataCount:0,
            rowSize:20,
            goPage:'',
            notNull:[],
            current:1,
            imgSrc:'',
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
 
        }
    },
    mounted () { 
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        getBaseData('xuper_auth/getBaseData','','','','','V_YRMTH','').then(res=>{
            this.mthArr =res.result
        })
        //用户表单新增、编辑、审核、作废权限  
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','445327','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })  
 
    },
    computed: {
        editHeight: function() {
            return (window.innerHeight - 300) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 130) + 'px';
        }, 
    },
    components: {
     
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            this.qryTabData()
            this.getTabField() //表列字段          
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        headStyle({row,column}){
            if (column.property=='RATIO' ){
                return 'color:red;height:28px'
            }
        },
        //表行点击事件
        rowClick(row){
            if (row['STFGNM']==='审核')  {  
                this.stfgColor='color:green'
                this.stfgCss='icon-yishenhe1'
            }else if (row['STFGNM']==='作废')  {  
                this.stfgColor='color:red'
                this.stfgCss='icon-yizuofei'
            }else{
                this.stfgColor='color:gray'
                this.stfgCss='icon-weishenhe3'
            }
 
        },
 
        //保存记录
        saveRec(){
            var vm =this 
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.perRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool) {  
                let obj_ ={}      
                Object.assign(obj_,vm.perRow,{ 'CORPID':this.v_corpid}) 
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(obj_), p_table:'bs_unit',frmid:'445327'},
                }).then(res=>{      
                    if(res.code ==='200')  {  
                        vm.addWin =false   
                        this.qryTabData()
                    }else{
                        if (res.result.indexOf('ORA-00001')){
                            this.prompt='已存在相同记录，请核查'
                        }else{
                            this.prompt=res.result
                        }
                        this.promptWin=true                       
                    }        
                }) 
            }
        },
        //状态审核
        recSet(row,val){
            let stfg_ =val==='Y'?'审核':val==='N'?'弃审':'作废'
            this.$confirm('你确定要'+stfg_+'此行记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                let cond_=''
                if (val==='Y'){
                    cond_=' set stfg=\''+val+'\',cfmdttm=\''+getDate('date')+'\' '
                }else{
                    cond_=' set stfg=\''+val+'\',cfmdttm=null ' 
                }
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ ,p_table:'bs_unit',p_cond:cond_ },
                }).then(res=>{      
                    if(res.code =='200')  {           
                        vm.qryTabData()     
                    }else{
                        this.promptWin=true
                        this.prompt=res.message
                    }        
                }) 
                 
            }).catch(()=>{})
        },
        //单位明细
        getTabList(cond){
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond+ ' order by '+this.selparam ,p_table:'V_HR_DING'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.tabData =res.result
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.tabref.doLayout()
                })
            }) 
        },
 
        editRec(row,val){

            this.saveFlag=false
            this.perRow =JSON.parse(JSON.stringify(row))
            this.addWin=true           
        },
        getRowKey(row){
            return row.IDSEQ
        },
        //查询
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and '+this.selparam+' like \'%' + this.txtparam+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam +this.oper+'\''+this.txtparam+'\''
                }
            }
            if (this.selparam2){ //列1
                if (this.oper2==='like'){
                    cond_=cond_+' and '+this.selparam2+' like \'%' + this.txtparam2+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam2 +this.oper2+'\''+this.txtparam2+'\''
                }
            }
            this.getTabList( cond_)
             
        },
 
        //下载记录
        downRec(){
            this.$confirm('你确定要下载钉钉通讯录的记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.loadWin =true
                //发起删除请求
                var vm=this
                this.$axios({
                    method: 'post',
                    url: '/xuper_oss/dingtalk/getdeptemp',
                    data: {},
                }).then(res=>{      
                    if(res.code =='200')  {      
                        let k=0     
                        res.result.forEach(item=>{                            
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/getBaseData',
                                data: {p_key2:'corpid', p_value2:this.v_corpid,p_cond:' and userid=\''+item['USERID']+'\'',p_table:'V_HR_DING'},
                            }).then(res2=>{
                                
                                if (res2.result.length==0){
                                    this.$axios({
                                        method: 'post',
                                        url:'xuper_auth/formOneSave',
                                        data: {p_json:JSON.stringify({USERID:item['USERID'],USERNM:item['USERNM'],CORPID:this.v_corpid,IDSEQ:''}), p_table:'HR_DING',frmid:'445327'},
                                    }).then(res3=>{  
                                    })
                                }
                            })
                            k++
                        }) 
                        //console.log(k,res.result.length)
                        if (k ==res.result.length ){
                            this.getTabList('')
                            this.loadWin=false
                        }
                    }else{
                        this.loadWin=false
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                })     
            }).catch(()=>{})
        },
 
 
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','445327','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
 
        }
    }
}
</script>
<style scoped lang="less">
 
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 48%;
        height:25px;
    }
    .active { 
        color:#D200D2; 
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-table__body {
        width: 100%;
        // 使表格兼容safari，不错位
        table-layout: fixed !important;
    }
 
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
 